export default __webpack_public_path__ + "bb4c46d9f61943b64722c2d4cf45451c.gif";